/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RestResponse } from '../model';
import { ApiHeaders } from './headers';
import { CrmError } from '../model/error';

@Injectable()
export class ErrorProvider {

  constructor(
    private http: HttpClient
  ) { }

  sendError(data: FormData): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/email/error`, data);
  }

  sendFeedback(error: CrmError): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/email/feedback`, {
        URL: error.URL,
        DATE: error.DATE,
        USER: error.USER.ID,
        COMMENTS: error.COMMENTS
      }, ApiHeaders.getOptions());
  }

}
